import {
  IntlProvider,
  load,
  loadMessages,
  LocalizationProvider,
} from "@progress/kendo-react-intl";
import currencyData from "cldr-core/supplemental/currencyData.json";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import weekData from "cldr-core/supplemental/weekData.json";
import caGregorian from "cldr-dates-full/main/fr/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/fr/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/fr/timeZoneNames.json";
import currencies from "cldr-numbers-full/main/fr/currencies.json";
import numbers from "cldr-numbers-full/main/fr/numbers.json";
import React, { Suspense, useEffect, useMemo, useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import DrawerRouterContainer from "./commons/navigations/DrawerRouterContainer";
import Loading from "./commons/status/AppLoading";
import routes from "./jsons/connected-routes.json";
import frMessages from "./jsons/fr-CA.json";
import Connection from "./pages/connection/Connection";
import FactoryComponent from "./pages/connection/FactoryComponent";
import MenuHeader from "commons/navigations/MenuHeader";
import { TOKEN, USER } from "constants/context";
import { setToken, setUser } from "./redux/slices/appStateSlice";
import { useDispatch } from "react-redux";
import LoaderContainer from "commons/container/LoaderContainer";
import { useLazyLoginWithTokenQuery } from "./redux/api/login";

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
);
loadMessages(frMessages, "fr-CA");

function App() {
  const dispatch = useDispatch();
  const [loginWithToken] = useLazyLoginWithTokenQuery();
  const [urlLoaded, setUrlLoaded] = useState(false);
  useEffect(() => {
    async function getUrlInfos() {
      var searchs = new URLSearchParams(window.location.href.split("?")[1]);
      if (searchs.get("applicatauthtoken") !== null) {
        let token = searchs.get("applicatauthtoken");
        let result = await loginWithToken(token).unwrap();
        let authorizationToken = result.headers.get("Authorization");
        localStorage.setItem(TOKEN, authorizationToken);
        localStorage.setItem(USER, result.body.usager);
        dispatch(setToken(authorizationToken));
        dispatch(setUser(result.body.usager));

        window.history.replaceState(
          null,
          "",
          window.location.href.split("?")[0]
        );
      } else if (
        searchs.get("token") !== null &&
        searchs.get("user") !== null
      ) {
        let token = searchs.get("token");
        localStorage.setItem(TOKEN, `Bearer ${token}`);
        localStorage.setItem(USER, searchs.get("user"));
        dispatch(setToken(`Bearer ${token}`));
        dispatch(setUser(searchs.get("user")));
        window.history.replaceState(
          null,
          "",
          window.location.href.split("?")[0]
        );
      }
      setUrlLoaded(true);
    }
    getUrlInfos();
  }, []);

  const pages = useMemo(() => {
    let allowedPages = [];
    const createPages = (routes, index) => {
      if (routes.subs !== undefined)
        for (let i = 0; i < routes.subs.length; i++) {
          createPages(routes.subs[i], index + "_" + i);
        }

      allowedPages.push(
        <Route
          key={index}
          path={routes.route}
          element={<FactoryComponent item={routes} />}
        />
      );
    };
    routes.forEach((route, i) => createPages(route, i));
    return allowedPages;
  }, []);

  return urlLoaded ? (
    <Connection>
      <HashRouter>
        <MenuHeader>
          <DrawerRouterContainer>
            <Suspense fallback={<Loading />}>
              <LocalizationProvider language="fr-CA">
                <IntlProvider locale="fr">
                  <Routes>{pages}</Routes>
                </IntlProvider>
              </LocalizationProvider>
            </Suspense>
          </DrawerRouterContainer>
        </MenuHeader>
      </HashRouter>
    </Connection>
  ) : (
    <LoaderContainer />
  );
}

export default App;
